// Formats a browser can paint in an <img>. TIFF is a supported upload but no mainstream
// browser renders it, so treating it as previewable downloads the whole blob to show a
// broken-image icon.
const IMAGE_EXTENSIONS = [".png", ".jpg", ".jpeg"];

const getFileExtension = (fileName: string): string => {
  const dotIndex = fileName.lastIndexOf(".");

  return dotIndex === -1 ? "" : fileName.slice(dotIndex).toLowerCase();
};

const isImageDocument = (fileName: string): boolean =>
  IMAGE_EXTENSIONS.includes(getFileExtension(fileName));

export default isImageDocument;
